import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MaterialModule } from '@base/material';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DirectivesModule } from '@directives/directives.module';

import * as fromEtl from '@etl/etl.reducer';
import { EtlEffects } from '@etl/etl.effects';
import { JobCardComponent } from './job-card/job-card.component';
import { EtlService } from '@etl/etl.service';
import { DetailsComponent } from '@etl/details/details.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    StoreModule.forFeature(fromEtl.etlFeatureKey, fromEtl.reducer),
    EffectsModule.forFeature([EtlEffects]),
    FontAwesomeModule,
    DirectivesModule,
  ],
  declarations: [JobCardComponent, DetailsComponent, ],
  exports: [JobCardComponent, DetailsComponent, ],
  providers: [EtlService, ]
})
export class EtlModule { }
